import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n/i18n";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all exceeded commission accounts
export const fetchExceededCommissionAccounts = createAsyncThunk(
  "exceeded_commission_accounts/fetchAll",
  async ({ page = 1, driver_id = "" } = {}, { rejectWithValue }) => {
    try {
      const q = new URLSearchParams();
      q.set("page", String(page));
      if (driver_id !== "" && driver_id != null && String(driver_id).trim() !== "") {
        q.set("driver_id", String(driver_id).trim());
      }
      const response = await axios.get(
        `${BASE_URL}/exceeded-commission-accounts?${q.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
            Lang: i18n.language,
          },
        }
      );
      return response.data; // Return the whole response including pagination
    } catch (error) {
      const message = error.response?.data?.message || "Failed load data";
      return rejectWithValue(message);
    }
  }
);

const ExceededCommissionAccountsSlice = createSlice({
  name: "exceeded_commission_accounts",
  initialState: {
    exceeded_commission_accounts: [],
    isLoading: false,
    error: null,
    success: null,
    pagination: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExceededCommissionAccounts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchExceededCommissionAccounts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.exceeded_commission_accounts = action.payload.data.data;
        state.pagination = action.payload.data.pagination;
      })
      .addCase(fetchExceededCommissionAccounts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load data";
      });
  },
});

export const { clearState } = ExceededCommissionAccountsSlice.actions;
export default ExceededCommissionAccountsSlice.reducer;
